import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ViewModule } from '@catalog/products/view/view.module';

import { AccessoryModalComponent } from '@app/modules/cross-sell/accessory/accessory-modal/accessory-modal.component';
import { OptionModalComponent } from '@app/modules/cross-sell/option/option-modal/option-modal.component';

import { ComingNextModalComponent } from '../base/modals/coming-next-modal/coming-next-modal.component';
import { SharedForAllModule } from '../base/shared-for-all.module';
import { TrilogyComponentsModule } from '../base/trilogy.module';
import { InfoHuaweiModalComponent } from './products/view/modals/info-huawei-modal/info-huawei-modal.component';
import { InternationalCallModalComponent } from './products/view/modals/international-call-modal/international-call-modal.component';
import { ModalCmsComponent } from './products/view/modals/modal-cms/modal-cms.component';
import { OdrRsfModalComponent } from './products/view/modals/odr-rsf-modal/odr-rsf-modal.component';
import { OldPriceDetailsModalComponent } from './products/view/modals/old-price-details-modal/old-price-details-modal.component';
import { PriceDetailsModalComponent } from './products/view/modals/price-details-modal/price-details-modal.component';

@NgModule({
    declarations: [
        InternationalCallModalComponent,
        OdrRsfModalComponent,
        PriceDetailsModalComponent,
        ComingNextModalComponent,
        ModalCmsComponent,
        InfoHuaweiModalComponent,
        AccessoryModalComponent,
        OptionModalComponent,
        ModalCmsComponent,
        OldPriceDetailsModalComponent,
    ],
    imports: [TrilogyComponentsModule, SharedForAllModule, CommonModule, ViewModule],
    providers: [],
    exports: [
        InternationalCallModalComponent,
        OdrRsfModalComponent,
        ComingNextModalComponent,
        ModalCmsComponent,
        PriceDetailsModalComponent,
        InfoHuaweiModalComponent,
        OldPriceDetailsModalComponent,
    ],
})
export class SharedModalsModule {}
